import { useEffect, useState } from "react";

/**
 * Desktop breakpoint aligned with Bootstrap lg (>= 992px)
 */
export default function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 992 : true
  );

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 992px)");

    const onChange = (e) => setIsDesktop(e.matches);

    // modern + fallback
    if (mq.addEventListener) mq.addEventListener("change", onChange);
    else mq.addListener(onChange);

    setIsDesktop(mq.matches);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return isDesktop;
}
